<template>
  <div class="list-box">
    <div class="nav gap-x-3" title="XiTong-Dictionary" data-title="数据字典">
      <el-input
        v-model="state.params.name"
        style="
          width: 300px;
          --el-input-bg-color: #f6f6f6;
          --el-input-border-color: #fff;
          --el-border-radius-base: 8px;
        "
        clearable
        placeholder="关键字"
        @keyup.enter="onLoad()"
        @clear="onLoad()"
      >
        <template #suffix>
          <el-icon
            color="#a2a2a2"
            title="搜索"
            class="font-bold cursor-pointer hover:opacity-60"
            ><Search
          /></el-icon>
        </template>
      </el-input>
      <el-button
        type="primary"
        icon="Plus"
        @click="
          delete state.selectId;
          state.showInfo = true;
        "
      >
        新建
      </el-button>
    </div>
    <div class="flex-1 overflow-hidden flex gap-x-3 mt-2">
      <div class="w-52 overflow-hidden flex flex-col gap-y-1">
        <ul class="flex items-center">
          <li class="flex-1 text-sm">字典类别</li>
          <el-button
            link
            size="small"
            type="primary"
            icon="Refresh"
            @click="onLoadCate"
          >
            刷新
          </el-button>
        </ul>
        <div class="overflow-y-auto pr-2">
          <!-- <el-segmented
            v-model="state.params.dictionary_cate_id"
            :options="state.cateData"
            :props="{
              value:'id'
            }"
            direction="vertical"
            class="w-full"
          >
            <template #default="{ item }">
              <div class="flex items-center">
                <span class="w-6">
                  <el-icon color="var(--el-fill-color-light)" 
                    ><Select
                  /></el-icon>
                </span>
                <div>{{ item.name }}</div>
              </div>
            </template>
          </el-segmented> -->

          <el-radio-group
            v-model="state.params.dictionary_cate_id"
            @change="onLoad()"
          >
            <el-radio
              v-for="(item, index) in state.cateData"
              :key="item"
              :value="item.id"
              size="large"
              style="width: 100%; margin: 0; border-radius: 0"
              :class="
                state.params.dictionary_cate_id == item.id || index == 0
                  ? '!border-t'
                  : ''
              "
              class="!border-t-0"
              border
              >{{ item.name }}</el-radio
            >
          </el-radio-group>
        </div>
      </div>
      <div class="content">
        <el-table
          :data="state.tableData"
          v-loading="!Array.isArray(state.tableData)"
          element-loading-background="rgba(0, 0, 0, 0.2)"
          :default-sort="{
            prop: state.params.sort_field,
            order:
              state.params.sort_value == 'desc' ? 'descending' : 'ascending',
          }"
          @sort-change="onSortChange"
          row-key="id"
          default-expand-all
        >
          <el-table-column
            fixed
            label="#"
            width="70"
            type="index"
            :index="
              (index) =>
                $buildTabIndex(state.params.page, state.params.limit, index)
            "
            align="center"
          />
          <el-table-column
            prop="name"
            sortable="name"
            label="名称"
            :formatter="
              (row, column, cellValue) =>
                $tab_Highlinght(cellValue, state.params.name)
            "
            min-width="220"
            show-overflow-tooltip
          />
          <el-table-column
            prop="description"
            label="说明"
            :formatter="$tab_TextFormat"
            min-width="260"
            show-overflow-tooltip
          />
          <el-table-column label="状态">
            <template #default="{ row }">
              <el-switch
                v-model="row.status"
                active-text="启用"
                inactive-text="禁用"
                :active-value="1"
                :inactive-value="0"
                :disabled="!row.id"
                inline-prompt
                @change="onUpdateStatus($event, row)"
              />
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            fixed="right"
            align="center"
            :width="160"
          >
            <template #default="{ row }">
              <el-button
                type="warning"
                :icon="Edit"
                link
                @click="
                  state.selectId = row.id;
                  state.showInfo = true;
                "
                >编辑
              </el-button>
              <el-button
                type="danger"
                :icon="Delete"
                link
                @click="onDelete(row)"
                >删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <c_page
          :total="state.totalCount"
          :pageIndex="state.params.page"
          :pageSize="state.params.limit"
          @onLoad="
            (page) => {
              state.params.page = page.pageIndex;
              state.params.limit = page.pageSize;
              onLoad();
            }
          "
        />
      </div>
    </div>
  </div>
  <el-dialog
    v-model="state.showInfo"
    :title="state.selectId ? '编辑数据字典' : '新建数据字典'"
    class="c-el-dialog"
    width="500"
    :before-close="
      () => {
        state.showInfo = false;
      }
    "
  >
    <c_info
      :id="state.selectId"
      :cateId="state.params.dictionary_cate_id"
      @close="
        (refresh) => {
          state.showInfo = false;
          if (refresh) onLoad();
        }
      "
    />
  </el-dialog>
</template>

<script>
import { onMounted, reactive } from "vue";
import {
  dictionary_cate_list,
  dictionary_page,
  dictionary_delete,
  dictionary_updateStatus,
} from "@/http/dictionary";
import { onDeleteConfirm, post_response } from "@/utils/funcs";
import { ElMessageBox } from "element-plus";

import c_info from "./Info.vue";

class InitFormData {
  params = {
    page: 1,
  };
}

export default {
  components: {
    c_info,
  },
  setup() {
    const state = reactive({
      ...new InitFormData(),
    });

    onMounted(() => {
      onLoadCate(true);
      onLoad();
    });

    const onLoadCate = () => {
      delete state.cateData;
      dictionary_cate_list().then((res) => {
        if (res.status == 200) {
          const { list } = res.data.data;
          state.cateData = list;

          if (list.length > 0) {
            state.params.dictionary_cate_id = list[0].id;
            onLoad();
          }
        }
      });
    };

    const onLoad = () => {
      delete state.tableData;

      dictionary_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count } = res.data?.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //删除
    const onDelete = (row) => {
      onDeleteConfirm(dictionary_delete, row.id, onLoad, {
        filed: "字典",
        name: row.name,
      });
    };

    const onUpdateStatus = (value, row) => {
      ElMessageBox.confirm(
        `您确定${
          row.status == 1
            ? '<strong style="color: var(--el-color-success);">启用</strong>'
            : '<strong style="color: var(--el-color-danger);">禁用</strong>'
        }该字典项吗？`,
        "状态变更",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          customClass: "c-delete-dialog",
          cancelButtonClass: "is-plain",
        },
      )
        .then(() => {
          dictionary_updateStatus({
            id: row.id,
            status: row.status,
          }).then((res) => {
            post_response(res, onLoad);
          });
        })
        .catch(() => {
          row.status = value ? 0 : 1;
        });
    };

    return { state, onLoad, onLoadCate, onDelete, onUpdateStatus };
  },
};
</script>

<style lang="scss" scoped></style>
